'use client';
import { useState } from 'react';

interface TestimonialProps {
    rating: number;
    quote: string;
    name: string;
    role: string;
    avatar: string;
}

const TestimonialCard = ({ rating, quote, name, role, avatar }: TestimonialProps) => (
    <div className="bg-background-warm border border-border-light rounded-xl sm:rounded-2xl lg:rounded-[20px] p-6 sm:p-8 lg:p-[30px] flex flex-col gap-6 sm:gap-7 lg:gap-[32px] h-full">
        {/* Rating Stars */}
        <div className="flex flex-row gap-1 sm:gap-1.5 lg:gap-[4px]">
            {[...Array(5)].map((_, index) => (
                <img
                    key={index}
                    src="/images/img_frame_yellow_900.svg"
                    alt=""
                    className="w-6 h-6 sm:w-7 sm:h-7 lg:w-[30px] lg:h-[30px]"
                />
            ))}
        </div>

        {/* Testimonial Quote */}
        <p className="text-base sm:text-lg lg:text-xl text-text-primary font-medium leading-relaxed" style={{ fontFamily: 'Figtree' }}>
            {quote}
        </p>

        {/* Customer Info */}
        <div className="flex flex-row items-center gap-4 sm:gap-5 lg:gap-[20px] mt-auto">
            <img
                src={avatar}
                alt={name}
                className="w-14 h-14 sm:w-16 sm:h-16 lg:w-[80px] lg:h-[80px] rounded-full object-cover"
            />
            <div className="flex flex-col gap-1">
                <h4 className="text-base sm:text-lg lg:text-xl text-text-primary font-semibold leading-tight" style={{ fontFamily: 'Figtree' }}>
                    {name}
                </h4>
                <p className="text-sm sm:text-base text-text-light font-normal leading-tight" style={{ fontFamily: 'Figtree' }}>
                    {role}
                </p>
            </div>
        </div>
    </div>
)

export default function TestimonialsSection() {
    const [currentSlide, setCurrentSlide] = useState(0)

    const testimonials: TestimonialProps[] = [
        {
            rating: 5,
            quote: '" Amazing quality and fast delivery! StyleHub is my go-to store now."',
            name: 'Cameron Williamson',
            role: 'Manager',
            avatar: '/images/img_ellipse_27.png'
        },
        {
            rating: 5,
            quote: '" Amazing quality and fast delivery! StyleHub is my go-to store now."',
            name: 'Cameron Williamson',
            role: 'Manager',
            avatar: '/images/img_ellipse_27.png'
        },
        {
            rating: 5,
            quote: '" Amazing quality and fast delivery! StyleHub is my go-to store now."',
            name: 'Cameron Williamson',
            role: 'Manager',
            avatar: '/images/img_ellipse_27.png'
        }
    ]

    return (
        <section className="w-full pt-10 sm:pt-14 lg:pt-16 pb-4 sm:pb-6 lg:pb-6">
            <div className="w-full max-w-[1920px] mx-auto px-4 sm:px-6 lg:px-[60px]">
                <div className="w-full flex flex-col gap-8 sm:gap-10 lg:gap-[32px]">
                    {/* Section Title */}
                    <h2 className="text-3xl sm:text-4xl lg:text-7xl text-text-primary font-semibold leading-tight text-center">
                        What Our Customers Say
                    </h2>

                    {/* Testimonials Grid */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 lg:gap-[30px]">
                        {testimonials.map((testimonial, index) => (
                            <TestimonialCard key={index} {...testimonial} />
                        ))}
                    </div>

                    {/* Slide Indicators */}
                    <div className="flex flex-row gap-2.5 sm:gap-3 items-center justify-center pt-2">
                        {[0, 1, 2].map((index) => (
                            <button
                                key={index}
                                onClick={() => setCurrentSlide(index)}
                                className={`rounded-full transition-all duration-300 ${currentSlide === index
                                        ? 'w-3.5 h-3.5 sm:w-4 sm:h-4 bg-text-primary scale-110 shadow-sm'
                                        : 'w-3 h-3 sm:w-3.5 sm:h-3.5 border-2 border-text-primary bg-transparent hover:bg-black/20'
                                    }`}
                                aria-label={`Go to testimonial ${index + 1}`}
                                aria-current={currentSlide === index}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}